module.exports = __webpack_public_path__ + "static/media/universities-icon-2.1fb06785.svg";